import RecordRTC, {StereoAudioRecorder} from 'recordrtc';
import {AudioHandler} from "./AudioHandler";

export class Linear16AudioHandler extends AudioHandler {
    protected stream: MediaStream | null = null;

    protected constraints: MediaStreamConstraints = {
        audio: {
            sampleRate: {ideal: 16_000},
            sampleSize: {ideal: 16},
            channelCount: {ideal: 1},
            echoCancellation: false,
            noiseSuppression: false,
            autoGainControl: false,
        },
    };
    private recorder: RecordRTC | null = null;

    async startRecording(stream: MediaStream) {
        console.info("[Linear16AudioHandler] starting audio input...");

        try {
            this.stream = stream;

            const [track] = this.stream.getAudioTracks();
            const settings = track.getSettings();
            console.log("[Linear16AudioHandler] Track settings:", settings);

            this.recorder = new RecordRTC(this.stream, {
                type: 'audio',
                mimeType: 'audio/wav',
                recorderType: StereoAudioRecorder,
                numberOfAudioChannels: 1,
                desiredSampRate: 16000,
                timeSlice: 250,
                ondataavailable: (blob: Blob) => {
                    blob.arrayBuffer()
                        .then(buffer => {
                            this.ws.send(buffer)
                        })
                        .catch(err =>
                            console.error('[Linear16AudioHandler] RecordRTC ondataavailable error:', err)
                        );
                }
            });

            this.recorder.startRecording();
        } catch (error) {
            console.error("[Linear16AudioHandler] Failed to set audio input:", error);
            throw error;
        }
    }

    async stop() {
        console.info("[Linear16AudioHandler] Stopping audio input...");
        this.recorder?.stopRecording();
        this.recorder = null
        this.stream = this.stopStream(this.stream)

        await super.stop()
    }
}
